"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.optionalTrimmedString = void 0;
const zod_1 = require("zod");
exports.optionalTrimmedString = zod_1.z
    .string()
    .trim()
    .max(120)
    .optional()
    .transform((v) => (v === undefined || v.length === 0 ? undefined : v));
//# sourceMappingURL=common.js.map